<template>
   <section>
      <article class="article-contact animated slide-in-left">
         <p class="title-articles blue">CONTÁCTANOS</p>
         <p class="title-article-2">Mándanos un <span class="blue">Mensaje</span></p>
         <div v-if="contactoDelPais" class="text-contact">
            <p class="red">{{ contactoDelPais.nombre }}:</p>
            <p class="info-contacto">
               <span v-if="contactoDelPais.direccion">Dirección: {{ contactoDelPais.direccion }}<br></span>
               <span v-if="contactoDelPais.correo">
                  Correo:
                  <a :href="`mailto:${contactoDelPais.correo}`" class="blue">{{ contactoDelPais.correo }}</a><br>
               </span>
               <span v-if="contactoDelPais.telefono">
                  Número Telefónico:
                  <a :href="`tel:${contactoDelPais.telefono}`" class="blue">{{ contactoDelPais.telefono }}</a>
               </span>
            </p>
         </div>
      </article>
      <article class="article-form">
         <form class="form-contact animated slide-in-right" @submit.prevent="enviarFormulario">
            <h1>PODEMOS AYUDARTE</h1>
            <div class="name-lastname">
               <label for="name">Nombre</label>
               <label for="last_name" class="lastname">Apellidos</label>
            </div>
            <div class="name-lastname">
               <input type="text" id="name" v-model="form.FirstName" required />
               <input type="text" id="last_name" v-model="form.SecondName" class="lastname" required />
            </div>
            <div class="name-lastname">
               <p class="text-help">Introduce tu nombre</p>
               <p class="text-help lastname">Introduce tu apellido</p>
            </div>
            <label for="email">Email</label><br>
            <input type="email" id="email" v-model="form.Email" required />
            <p class="text-help">Example: mail@piplatam.com</p>
            <label for="filial">Filial</label><br>
            <select id="filial" v-model="form.Filial" required class="input">
               <option v-for="(filial, key) in contactos" v-bind:key="key" :value="key">
                  {{ filial.label }}</option>
            </select>
            <p class="text-help">Selecciona la filial correspondiente</p>
            <label for="comentario">Mensaje</label><br>
            <textarea v-model="form.Message"></textarea>
            <p class="text-help">¿Cómo podemos ayudarte?</p>
            <div class="button-container">
               <button class="button-blue">Enviar</button>
            </div>
         </form>
         <div v-if="mostrarModal" class="modal-mensaje" :class="{ 'modal-error': errorAlEnviar }">
            <p>{{ mensajeModal }}</p>
         </div>
      </article>
   </section>
</template>

<script>
import { useGeo } from '@/composables/useGeo';

export default {
   name: 'ContactPage',
   inject: ["url"],
   data() {
      return {
         contactos: {},
         pais: null,
         form: {
            FirstName: "",
            SecondName: "",
            Company: "",
            Position: "",
            Email: "",
            Filial: "",
            Country: "",
            City: "",
            Message: "",
            Type: 'c'
         },
         mostrarModal: false,
         mensajeModal: "",
         errorAlEnviar: false
      };
   },

   computed: {
      contactoDelPais() {
         return this.contactos[this.pais] || this.contactos['MX'];
      }
   },

   created() {
      this.obtenerFiliales()
   },

   methods: {
      async obtenerFiliales() {
         try {
            const response = await fetch(`${this.url}subsidiaries`, {
               method: "GET"
            });
            const result = await response.json();
            if (response.ok && result.StatusCode === 200) {
               this.contactos = result.Data;
               const keys = Object.keys(this.contactos);
               for (let key in keys) {
                  if (this.contactos[keys[key]].country === this.pais) this.pais = keys[key];
               }
            } else {
               console.error("Error al obtener filiales:", result.Message);
            }
         } catch (error) {
            console.error("Error al llamar al API:", error);
         }
      },

      async enviarFormulario() {
         const path = `${this.url}sendemail`
         try {
            const response = await fetch(path, {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
               },
               body: JSON.stringify(this.form),
            });
            if (!response.ok) throw new Error('Error al enviar el formulario');

            await response.json();

            this.mostrarModal = true;
            this.mensajeModal = '¡Formulario enviado con éxito!';
            this.errorAlEnviar = false;

            // Limpiar campos
            Object.keys(this.form).forEach(key => {
               if (key !== 'Type') this.form[key] = "";
            });
         } catch (error) {
            console.error('Hubo un error al enviar el formulario:', error);
            this.mostrarModal = true;
            this.mensajeModal = 'Hubo un error al enviar el formulario.';
            this.errorAlEnviar = true;
         } finally {
            setTimeout(() => {
               this.mostrarModal = false;
            }, 5000);
         }
      }
   },

   mounted() {
      const { geoData, loadGeoData } = useGeo();
      loadGeoData().then(() => {
         this.pais = geoData.value.country_name;
      });
   }
};
</script>

<style scoped>
section {
   background: rgb(1, 1, 36);
   background: -moz-linear-gradient(90deg, rgba(1, 1, 36, 1) 0%, rgba(16, 21, 77, 1) 100%);
   background: -webkit-linear-gradient(90deg, rgba(1, 1, 36, 1) 0%, rgba(16, 21, 77, 1) 100%);
   background: linear-gradient(90deg, rgba(1, 1, 36, 1) 0%, rgba(16, 21, 77, 1) 100%);
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010124", endColorstr="#10154d", GradientType=1);
   min-height: 100vh;
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
}

.article-contact {
   width: 37%;
   margin: 0 0 0 auto;
   padding: 20px;
   box-sizing: border-box;
}

.red {
   color: #d83127;
   margin: 0 !important;
}

.info-contacto {
   width: 85%;
   margin-top: 0;
}

.info-contact i {
   margin-right: 10px;
}

.article-form {
   width: 30%;
   margin: 0 auto 0 0;
}

.form-contact {
   padding: 20px;
   background-color: #21244d;
   box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
   border-radius: 8px;
}

.name-lastname {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   width: 100%;
}

.name-lastname p {
   width: 100%;
}

.modal-mensaje {
   position: fixed;
   bottom: 20px;
   left: 50%;
   transform: translateX(-50%);
   background-color: #28a745;
   color: white;
   padding: 12px 24px;
   border-radius: 10px;
   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
   font-weight: bold;
   z-index: 1000;
   animation: fadeInOut 5s ease-in-out forwards;
}

.modal-error {
   background-color: #dc3545;
}

.lastname {
   margin-left: 1em;
}

label {
   margin-right: auto;
}

input,
textarea,
select,
option {
   border: none;
   border-radius: 8px;
   font-size: 16px;
   font-family: 'Montserrat', sans-serif;
   font-weight: 600;
}

input,
select {
   height: 40px;
   width: 100%;
   text-align: center;
}

textarea {
   height: 100px;
   width: 445px;
   resize: none;
   padding: 10px;
}

.button-container {
   display: flex;
   justify-content: center;
}

.text-help {
   font-size: 0.7em;
   color: rgba(255, 255, 255, 0.6);
   margin: 0.4em 0 0.5em 0;
}

a {
   text-decoration: none !important;
}


@media (max-width: 1600px) {

   .article-contact {
      width: 40%;
      margin-top: 2.8em;
   }

   .article-form {
      margin-top: 5em;
      margin-left: 2em;
      width: 35%;
   }

   .text-contact {
      width: 100%;
   }

   .info-contact {
      margin: 1em 0 0 1em;
   }
}

@media (max-width: 1200px) {
   .article-contact {
      width: 40%;
      margin-top: 2.8em;
   }

   .article-form {
      margin-top: 3em;
      margin-left: 2em;
      width: 45%;
   }

   .text-contact {
      width: 100%;
   }

   .info-contact {
      margin: 1em 0 0 1em;
   }

   .info-contacto {
      width: 100%;
      margin-top: 0;
   }
}

@media (max-width: 768px) {
   section {
      flex-direction: column;
      justify-content: left;
      height: auto;
   }

   .article-contact {
      width: 100%;
      margin-top: 2.5em;
   }

   .article-form {
      width: 100%;
      margin: 0;
   }

   .text-contact {
      width: 100%;
   }

   .info-contact {
      margin: 1em 0 0 1em;
   }
}
</style>